<section class="legal-shell">
  <div class="legal-card">
    <p class="eyebrow">Page publique</p>
    <h1>Suppression des données</h1>
    <p class="lead">
      Pour demander la suppression des données de votre compte AfriFood, envoyez un email à
      <a href="mailto:support.afrifood@afrimoov.com">support.afrifood@afrimoov.com</a>.
    </p>

    <div class="section">
      <h2>Contenu attendu dans l’email</h2>
      <ul>
        <li>Objet : <strong>Demande de suppression des données</strong>.</li>
        <li>L’adresse email utilisée pour votre compte AfriFood.</li>
        <li>Votre nom ou nom affiché dans l’application.</li>
        <li>Tout élément utile permettant d’identifier le compte.</li>
      </ul>
    </div>

    <div class="section">
      <h2>Suite de la procédure</h2>
      <ul>
        <li>Le support peut vous demander de confirmer que vous êtes bien propriétaire du compte.</li>
        <li>Après vérification, la demande sera traitée dans un délai raisonnable.</li>
        <li>Certaines données peuvent être conservées pour la prévention de la fraude ou pour des obligations légales.</li>
      </ul>
    </div>

    <div class="section">
      <h2>Contact support</h2>
      <p>
        Email:
        <a href="mailto:support.afrifood@afrimoov.com">support.afrifood@afrimoov.com</a>
      </p>
    </div>

    <div class="actions">
      <a routerLink="/privacy-policy">Voir la politique de confidentialité</a>
      <a routerLink="/">Retour à l’accueil</a>
    </div>
  </div>
</section>
